import types from './types'

function categoriesEvent(data = {}) {
  return { type: types.CATEGORIES_EVENT, category: data }
}

export default {
  categoriesEvent
}